import React, { useState } from "react";
import { Button } from "@blueprintjs/core";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Group, TextInput } from "@mantine/core";

import { AppToaster } from "@components";

import { mailingListSignup } from "../api";

export const MailingListBox: React.FC<{}> = () => {
  const [emailValue, setEmailValue] = useState<string>("");
  const [submitted, setSubmitted] = useState<boolean>(false);

  return (
    <form
      onSubmit={async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
          await mailingListSignup(emailValue);
        } catch (err: any) {
          AppToaster.show({
            message: `Error signing up for the mailing list: ${err.message}`,
            intent: "danger",
          });
          return;
        }
        AppToaster.show({
          message: `Thanks for signing up for the mailing list!`,
          intent: "success",
        });
        setSubmitted(true);
        setEmailValue("");
      }}
    >
      <Group spacing="xs">
        <TextInput
          sx={{ border: "1px solid var(--global-green)", borderRadius: "5px" }}
          type="email"
          placeholder={
            submitted ? "Thanks for signing up!" : "Enter your email here"
          }
          value={emailValue}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setEmailValue(event.target.value);
          }}
          name="email"
          disabled={submitted}
          required
          autoComplete="off"
        />
        {(submitted || emailValue.length > 0) && (
          <Button disabled={submitted} intent="primary">
            {submitted ? <FontAwesomeIcon icon={faCheck} /> : "I’m in!"}
          </Button>
        )}
      </Group>
    </form>
  );
};
